import { categoriesIcons } from './categories-icons'
import { commonIcons } from './common-icons'
import { localeIcons } from './locale-icons'

// Added new SVG — run `pnpm dlx svgo -rf src/components_new/Icon`

export const icons = {
    ...commonIcons,
    ...categoriesIcons,
    ...localeIcons,
}

export type IconNameType = keyof typeof icons
